import { Button, Container, Grid, Typography } from "@material-ui/core";
import React from "react";
import { history } from "../";

export default function NoUserRights() {
  return (
    <Container maxWidth='md'>
      <Grid container direction='column' alignItems='center'>
        <Grid item>
          <Typography variant='h6' color='error' style={{ marginTop: "24px" }}>
            Toestemming geweigerd omdat u niet genoeg gebruikersrechten heeft
            voor deze bewerking
          </Typography>
        </Grid>
        <Grid item>
          <Button
            variant='contained'
            color='primary'
            style={{ marginTop: "16px" }}
            onClick={() => history.goBack()}
          >
            Ga terug...
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant='contained'
            color='primary'
            style={{ marginTop: "16px" }}
            onClick={() => history.push("/")}
          >
            Dashboard
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant='contained'
            color='primary'
            style={{ marginTop: "16px" }}
            onClick={() => history.push("/administrations")}
          >
            Administraties
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
}
